/**
 * SEO for the public login route (`/auth/login`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export type LoginPageSeoLoaderInput = Record<string, never>

export function loginPageHeadFromLoaderData(_loaderData?: LoginPageSeoLoaderInput | null | undefined) {
  const pageUrl = absoluteUrlForPath('/auth/login')
  const description =
    'Sign in to Spicy Friends to message friends, RSVP to events, and manage groups. Use your email and password here, or use Forgot Password if you are locked out.'

  return seo({
    title: `Sign in to your account | ${env.VITE_APP_NAME}`,
    description,
    url: pageUrl,
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
